<template>
  <div class="c-slide">
    <div class="c-slide__wrap">
      <img
        ref="slideImg"
        v-for="n in max"
        :style="setImgStyle()"
        :src="`${assets_path}/img/mv/photo${n}.jpg`" alt="" width="1280" height="854" />
    </div>
  </div>
</template>

<script>
  import { breakpoint, assets_path } from '@/_constant/variables';
  import store from '@/_modules/utils/stores';
  import { gsap, Cubic } from 'gsap/all';

  export default {
    props: ['max'],
    data() {
      return {
        assets_path: assets_path,
        isLoaded: false,
        isSp: false,
        isStarted: false,
        imgStyle: '',
        size: {
          pc: {
            header: 105
          },
          sp: {
            header: 0
          }
        },
        slideTimer: null,
        current: 0,
        params: [
          {brightness: 3, contrast: 1, opacity: 0},
          {brightness: 3, contrast: 1, opacity: 0},
          {brightness: 3, contrast: 1, opacity: 0},
          {brightness: 3, contrast: 1, opacity: 0},
          {brightness: 3, contrast: 1, opacity: 0},
        ],
        params2: [
          {brightness: 1, contrast: 1, opacity: 1},
          {brightness: 1, contrast: 1, opacity: 1},
          {brightness: 1, contrast: 1, opacity: 1},
          {brightness: 1, contrast: 1, opacity: 1},
          {brightness: 1, contrast: 1, opacity: 1},
        ],
      }
    },
    store,
    computed: {
      setImgStyle: function () {
        return function () {
          return this.imgStyle;
        }
      },
    },
    mounted() {
      //this.$nextTick(this.init);
    },
    methods: {
      init() {
        console.log('init');
        this.resize();
        window.addEventListener('resize', this.resize);

        this.$nextTick(this.start);
      },
      start() {
        if (this.isStarted) return;
        this.isStarted = true;

        if (this.isSp) {
          // 並べるだけ
        } else {
          // スライドショー1枚目を表示
          this.showSlide(this.current);
          this.slideTimer = setTimeout(this.nextSlide, 4000);
        }
      },
      nextSlide(num) {
        let next;
        if (num !== undefined) {
          next = num;
        } else {
          next = (this.current + 1) % this.max;
        }

        this.hideSlide(this.current, 0);
        this.showSlide(next, 0.7);

        this.current = next;
        this.$parent.setCurrent(next);

        this.slideTimer = setTimeout(this.nextSlide, 4500);
      },
      hideSlide(num, delay) {
        const refImg = this.$refs['slideImg'][num];
        gsap.killTweensOf(refImg);
        gsap.to(this.params2[num], {
          delay: delay,
          duration: 1.4,
          brightness: 3,
          contrast: 1,
          opacity: 0,
          ease: Cubic.easeInOut,
          onUpdate: function(refImg, param) {
            gsap.set(refImg, {
              opacity: param.opacity,
              '-webkit-filter': 'contrast(' + param.contrast + ') brightness(' + param.brightness + ')',
              'filter': 'contrast(' + param.contrast + ') brightness(' + param.brightness + ')',
            });
          },
          onUpdateParams: [refImg, this.params2[num]],
          onComplete: this.hideSlideComp,
          onCompleteParams: [refImg, this.params2[num]],
        });
      },
      hideSlideComp(refImg, param) {
        // パラメータ初期化
        gsap.set(refImg, {clearProps: 'all'});
        refImg.style.visibility = 'hidden';
        param.opacity = 1;
        param.contrast = 1;
        param.brightness = 1;
      },
      showSlide(num, delay) {
        const refImg = this.$refs['slideImg'][num];
        gsap.killTweensOf(refImg);
        gsap.set(refImg, {opacity: 0, visibility: 'visible'});
        gsap.to(this.params[num], {
          delay: delay,
          duration: 1.4,
          brightness: 1,
          contrast: 1,
          opacity: 1,
          ease: Cubic.easeOut,
          onUpdate: function(refImg, param) {
            gsap.set(refImg, {
              opacity: param.opacity,
              '-webkit-filter': 'contrast(' + param.contrast + ') brightness(' + param.brightness + ')',
              'filter': 'contrast(' + param.contrast + ') brightness(' + param.brightness + ')',
            });
          },
          onUpdateParams: [refImg, this.params[num]],
          onComplete: this.showSlideComp,
          onCompleteParams: [refImg, this.params[num]],
        });
      },
      showSlideComp(refImg, param) {
        param.opacity = 0;
        param.contrast = 1;
        param.brightness = 3;
      },
      changeSlide(num) {
        clearTimeout(this.slideTimer);
        this.nextSlide(num);
      },
      reset() {
        if (this.isStarted) {
          this.isStarted = false;

          clearTimeout(this.slideTimer);

          for (let i = 0; i < this.max; i++) {
            const refImg = this.$refs['slideImg'][i];
            gsap.killTweensOf([refImg, this.params[i]]);
            gsap.set(refImg, {clearProps: 'all'});
          }

          this.params = [
            {brightness: 3, contrast: 1, opacity: 0},
            {brightness: 3, contrast: 1, opacity: 0},
            {brightness: 3, contrast: 1, opacity: 0},
            {brightness: 3, contrast: 1, opacity: 0},
            {brightness: 3, contrast: 1, opacity: 0},
          ];
          this.params2 = [
            {brightness: 1, contrast: 1, opacity: 1},
            {brightness: 1, contrast: 1, opacity: 1},
            {brightness: 1, contrast: 1, opacity: 1},
            {brightness: 1, contrast: 1, opacity: 1},
            {brightness: 1, contrast: 1, opacity: 1},
          ];

          this.start();
        }
      },
      resize() {
        this.isSp = this.getMatchMedia();

        if (this.isSp) {
          this.$el.style.height = '';
          this.imgStyle = '';
        } else {
          const imgHeight = this.$refs['slideImg'][0].clientHeight;
          const frameHeight = window.innerHeight - this.size.pc.header;

          if (imgHeight < frameHeight) {
            this.$el.style.height = imgHeight + 'px';
            this.imgStyle = 'top: 0px;';

          } else {
            this.$el.style.height = frameHeight + 'px';

            const top = (frameHeight - imgHeight) * 0.5;
            this.imgStyle = `top: ${top}px;`;
          }
        }

        this.reset();
      },
      getMatchMedia() {
        return window.matchMedia('(max-width: 900px)').matches;
      }
    }
  }
</script>
